import { create } from 'zustand'

/**
 * Глобальные тосты взамен нативного window.alert().
 *
 * Использование (в любом компоненте/хуке/модуле):
 *   import { toast } from '@/shared/ui/toastStore'
 *   toast.error('Не удалось сохранить')
 *   toast.success('Скопировано')
 *   toast.info('Курсы не изменились')
 *
 * Хост <ToastHost/> смонтирован один раз в App. Store глобальный.
 */
export type ToastType = 'success' | 'error' | 'info'

export interface ToastItem {
  id: number
  text: string
  type: ToastType
}

interface ToastState {
  toasts: ToastItem[]
  push: (text: string, type: ToastType) => void
  dismiss: (id: number) => void
}

let seq = 0
const DURATION_MS = 5000

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (text, type) => {
    const id = ++seq
    set((state) => ({ toasts: [...state.toasts, { id, text, type }] }))
    setTimeout(() => {
      set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }))
    }, DURATION_MS)
  },
  dismiss: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}))

export const toast = {
  success: (text: string) => useToastStore.getState().push(text, 'success'),
  error: (text: string) => useToastStore.getState().push(text, 'error'),
  info: (text: string) => useToastStore.getState().push(text, 'info'),
}
